import type { FaireProductEntity } from "../../entity_types/product";

export const p_k8hwcku4jq: FaireProductEntity = {
  token: "p_k8hwcku4jq",
  type: "product",
  name: "Moon Crane Hand-Painted Porcelain Mug with Saucer Lid – 13 oz",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/eb15bc4c5ab186065ca4503d1d7a7b7bb10355c8098577a0b5da59e9fa498e88.png",
  galleryImageUrls: [],
  priceDollars: 7.5,
  description: "Enjoy coffee or tea in this 13 oz footed porcelain mug with a hand-painted Japanese moon crane design and a matching saucer lid. Red-crowned cranes fly among swirling clouds across a golden moon on a red body, with a red foot, handle and lid. The matching lid sits on top of the mug and doubles as a small saucer. Microwave and dishwasher safe, it is built for cafés, restaurants and gift shops, and looks just as good on the kitchen counter at home. A thoughtful gift for tea and coffee lovers.\n\nFeatures\n\n * Hand-painted: each design is painted by hand, so every mug has its own character \n * Saucer lid: a matching lid that doubles as a small saucer \n * Footed shape: a raised foot and a comfortable handle \n * Easy care: microwave and dishwasher safe \nSpecifications\n\n * Size: 4\" H \n * Capacity: 13 fl oz \n * Material: Porcelain \n * Decoration: Hand-painted \n * Design: Moon Crane \n * Includes: Mug and saucer lid \n * Inner pack: 4 \n * Case pack: 32 \n * Origin: China \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 16.87,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:47.275Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
